import {
  UPDATE_CUSTOM_STATUS_GRID,
  UPDATE_CUSTOM_STATUS_PROPERTY_ENABLE,
  UPDATE_CUSTOM_STATUS_EDIT_MODE,
  RESET_CUSTOM_STATUS_STATE,
  UPDATE_CUSTOM_STATUS_EDIT_GRID,
  UPDATE_CUSTOM_STATUS_PUBLISHED_IN_EDIT_MODE
} from '../actionTypes';
import { ICustomStatusState } from '../stateTypes';
import { ICustomStatus } from '../../utils/indexedDb/customStatus';

const initialState: ICustomStatusState = {
  grid: [],
  unsaveGrid: [],
  isPropertyEnable: false,
  isEditMode: false,
  editGrid: [],
  isPublishedInEditMode: false
};

interface UpdateCustomStatusGridAction {
  type: typeof UPDATE_CUSTOM_STATUS_GRID;
  payload: ICustomStatus[];
}

interface UpdateCustomStatusPropertyEnableAction {
  type: typeof UPDATE_CUSTOM_STATUS_PROPERTY_ENABLE;
  payload: boolean;
}

interface UpdateCustomStatusEditModeAction {
  type: typeof UPDATE_CUSTOM_STATUS_EDIT_MODE;
  payload: boolean;
}

interface UpdateCustomStatusEditGridAction {
  type: typeof UPDATE_CUSTOM_STATUS_EDIT_GRID;
  payload: ICustomStatus[];
}

interface UpdateCustomStatusPublishedInEditModeAction {
  type: typeof UPDATE_CUSTOM_STATUS_PUBLISHED_IN_EDIT_MODE;
  payload: boolean;
}

interface ResetCustomStatusStateAction {
  type: typeof RESET_CUSTOM_STATUS_STATE;
}

type CustomStatusActionType = 
  | UpdateCustomStatusGridAction
  | UpdateCustomStatusPropertyEnableAction
  | UpdateCustomStatusEditModeAction
  | UpdateCustomStatusEditGridAction
  | UpdateCustomStatusPublishedInEditModeAction
  | ResetCustomStatusStateAction;

export function customStatusReducer(
  state = initialState,
  action: CustomStatusActionType
): ICustomStatusState {
  switch (action.type) {
    case UPDATE_CUSTOM_STATUS_GRID:
      return {
        ...state,
        unsaveGrid: action.payload
      };
    case UPDATE_CUSTOM_STATUS_PROPERTY_ENABLE:
      return {
        ...state,
        isPropertyEnable: action.payload
      };
    case UPDATE_CUSTOM_STATUS_EDIT_MODE:
      return {
        ...state,
        isEditMode: action.payload
      };
    case UPDATE_CUSTOM_STATUS_EDIT_GRID:
      return {
        ...state,
        editGrid: action.payload
      };
    case UPDATE_CUSTOM_STATUS_PUBLISHED_IN_EDIT_MODE:
      return {
        ...state,
        isPublishedInEditMode: action.payload
      };
    case RESET_CUSTOM_STATUS_STATE:
      return initialState;
    default:
      return state;
  }
}
